import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Box, Grid, Typography } from '@mui/material'
import SelectField from '../../../../FormControl/input/SelectField'

const FormCurriculumElements = ({ onChangeAlert }) => {
  const formData = useSelector((state) => state?.dr?.form?.curriculumElements || {})
  const formError = useSelector((state) => state?.dr?.formError || {})
  const currentCurriculum = useSelector((state) => state?.assessment?.currentCurriculum || {})
  const [form, setInputForm] = React.useState(formData)
  const [errors, setInputErrors] = React.useState({})

  if (!currentCurriculum || !currentCurriculum?.elements || !currentCurriculum.elementsStructure) return <></>
  const onChange = (name, value) => {
    let formData = { ...form }

    if (name === 'elementId') {
      formData = { ...form, subElementId: null, [name]: value }
    } else {
      formData = { ...form, [name]: value }
    }
    setInputForm(formData)
    setInputErrors({ ...errors, [name]: null })
    onChangeAlert('curriculumElements', formData)
  }

  const element = currentCurriculum?.elements;
  const elementChildren = element.children.find((item) => item._id === form.elementId?.value);
  const subElement = elementChildren?.elements[0];

  useEffect(() => {
    setInputErrors(formError)
  }, [formError])

  return (
    <>
      <Box className='px-4 py-2 h-6 bg-primary text-primary-foreground flex items-center'>
        <Typography variant='inherit' className='font-bold capitalize' component='p'>
          Curriculum Elements
        </Typography>
      </Box>
      <Box className='px-4 py-4'>
        <Grid container spacing={2}>
          <Grid item md={2} sm={3}>
            <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
              {currentCurriculum.elementsStructure?.name}
            </Typography>
          </Grid>
          <Grid item md={9} sm={8}>
            <SelectField
              id={`elementId-${element?.elementStructureId}`}
              name='elementId' 
              error={errors.elementId}
              helperText={errors.elementId}
              value={form.elementId?.value || ''}
              onChange={(e) => onChange('elementId', { key: element?.elementStructureId, value: e.target.value })}      
              options={element.children?.map((item) => ({ value: item._id, label: item.name })) || [] }
              placeholder="Choose an option"
            />
          </Grid>
          { subElement && currentCurriculum.elementsStructure?.children[0] && (
            <>
            <Grid item md={2} sm={3}>
              <Typography variant='inherit' className='font-bold capitalize' color='primary' align='right' component='p'>
                {currentCurriculum.elementsStructure?.children[0]?.name}
              </Typography>
            </Grid>
            <Grid item md={9} sm={8}>
              <SelectField
                id={`subElementId-${currentCurriculum.elementsStructure?.children[0]?._id}`}
                name='subElementId' 
                error={errors.subElementId}
                helperText={errors.subElementId}
                value={form.subElementId?.value || ''}
                onChange={(e) => onChange('subElementId', { key: subElement?.elementStructureId, value: e.target.value })}      
                options={subElement?.children?.map((item) => ({ value: item._id, label: item.name })) || [] }
                placeholder="Choose an option"
              />
            </Grid>
            </>
          )}
        </Grid>
      </Box>
    </>
  )
}

export default FormCurriculumElements